import { Route, Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { POSITION_SLOT_LIST_READ } from 'domain/people/positionSlots/constants';
import { WORKFORCE_ANALYTICS_PATH } from 'domain/people/workforceAnalytics/constants';
import { useWorkforceAnalyticsRoute } from 'domain/people/workforceAnalytics/routing';
import WorkforceAnalyticsPage from 'domain/people/workforceAnalytics/List';

const WorkforceAnalyticsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useWorkforceAnalyticsRoute();

  return (
    <ProtectedRouter basePath={WORKFORCE_ANALYTICS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={POSITION_SLOT_LIST_READ}>
              <WorkforceAnalyticsPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

WorkforceAnalyticsRouter.getRouterPath = () => `${WORKFORCE_ANALYTICS_PATH}/*`;

export default WorkforceAnalyticsRouter;
